module.exports = __webpack_public_path__ + "static/media/bookmark.5d79db7c.svg";